export enum Resources {
  users = 'users',
  files = 'files',
  // prompt = 'prompt',
  // history = 'history',
  // product = 'products',
  // files_product = 'files_product',
  models = 'models',
  feeds = 'feeds',
  materials = 'materials',
  material_tests = 'material_tests',
  digests = 'digests',
  products = 'products',
  // chats = 'chats',
  // jivo_chats = 'jivo_chats',
  // categories = 'categories',
  // insales = 'insales',
  // insales_products = 'insales_products',
}
